import { jwtDecode } from "jwt-decode";

const userData = {
  data() {
    return {
      userData: null,
      userFullName: null,
      userId: null,
      userName: null,
      userEmail: null,
      userLevel: null,
      userAccess: null,
      userToken: null,
      // userPhoto: "../assets/img/user.png",
    };
  },
  created() {
    const userData = localStorage.getItem("userData");
    if (userData) {
      this.userData = JSON.parse(userData);
      this.userFullName = this.userData.full_name;
      this.userPhoto = this.userData.image_profil;
      const decodedToken = jwtDecode(this.userData.token);
      this.userId = decodedToken.id;
      this.userName = decodedToken.username;
      this.userLevel = decodedToken.level;
      this.userAccess = decodedToken.access_rights;
      this.userToken = this.userData.token;
      // this.userPhoto = this.userData.foto;
    }
  },
};

export default userData;

// export default {
//   data() {
//     return {
//       userData: null,
//       userId: null,
//       userName: null,
//       userEmail: null,
//       userLevel: null,
//       userAccess: null,
//       userToken: null,
//       userPhoto: "../assets/img/user.png",
//     };
//   },
//   created() {
//     const userData = localStorage.getItem("userData");
//     if (userData) {
//       this.userData = JSON.parse(userData);
//       this.userId = this.userData.id;
//       this.userName = this.userData.nama;
//       this.userEmail = this.userData.email;
//       this.userLevel = this.userData.level;
//       this.userAccess = this.userData.hak_akses;
//       this.userToken = this.userData.token;
//       // this.userPhoto = this.userData.foto;
//     }
//   },
// };
